'use client';
import {createGlobalStyle} from "styled-components";
import reset from "styled-reset";
import {SIZES} from "@/components/constants";

const GlobalStyle = createGlobalStyle`


    ${reset}


    // TODO: 2026-05-13 3번 내용 필요시 추가
    //*,
    //*::before,
    //*::after {
    //    box-sizing: border-box;
    //}
    //
    //* {
    //    font-family: 'Pretendard', sans-serif !important;
    //    margin: 0;
    //}
    //
    //html {
    //    -webkit-text-size-adjust: 100%;
    //    text-size-adjust: 100%;
    //}
    //
    //html:focus-within {
    //    scroll-behavior: smooth;
    //}
    //
    //
    //
    //html, body {
    //    margin: 0;
    //    height: 100%;
    //    overflow: hidden;
    //    -webkit-font-smoothing: antialiased;
    //    -moz-osx-font-smoothing: grayscale;
    //    text-rendering: optimizeLegibility;
    //}
    //#root {
    //    position: relative;
    //}
    //
    //img,
    //picture,
    //video,
    //canvas,
    //svg {
    //    vertical-align: top;
    //    max-width: 100%;
    //}
    //
    //img {
    //    border: 0;
    //    max-width: 100%;
    //    width: 100%;
    //}
    //
    //a {
    //    text-decoration: none;
    //    color: inherit;
    //    cursor: pointer;
    //}
    //
    //ul,
    //ol,
    //li {
    //    list-style: none;
    //    padding: 0;
    //}
    //
    //label,
    //input {
    //    vertical-align: middle;
    //}
    //
    //input,
    //button,
    //textarea,
    //select {
    //    font: inherit;
    //    color: inherit;
    //}
    //
    //button {
    //    border: 0;
    //    background: none;
    //    cursor: pointer;
    //    outline: 0;
    //    padding: 0;
    //}
    //
    //table {
    //    width: 100%;
    //    border-collapse: collapse;
    //    border-spacing: 0;
    //    table-layout: fixed;
    //}
    //
    //p,
    //h1,
    //h2,
    //h3,
    //h4,
    //h5,
    //h6 {
    //    overflow-wrap: break-word;
    //    font-size: inherit;
    //}

    @font-face {
        font-family: 'Pretendard';
        font-weight: 100;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Thin.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 200;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-ExtraLight.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 300;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Light.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 400;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Regular.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 500;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Medium.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 600;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-SemiBold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 700;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Bold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 800;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-ExtraBold.woff2') format('woff2');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 900;
        font-display: swap;
        src: url('https://cdn.jsdelivr.net/gh/fonts-archive/Pretendard/Pretendard-Black.woff2') format('woff2');
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    * {
        font-family: 'Pretendard', sans-serif !important;
        //&::-webkit-scrollbar {
        //    width: 6px;
        //    height: 8px;
        //}
        //&::-webkit-scrollbar-track {
        //    background: transparent;
        //}
        //&::-webkit-scrollbar-thumb {
        //    background: rgba(0, 0, 0, 0.10);
        //    border-radius: 100px;
        //}
    }
    html, body { height: 100%; overflow: hidden; }


    body {
        //background-color: #fff;
    }
    .fp-watermark {
        display: none !important;
    }
    html, body {
        margin: 0;
        height: 100%;
        //scroll-snap-type: y mandatory;
        //overflow-y: scroll;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
    }
    #root {
        position: relative;
    }

    button {
        cursor: pointer;
        background: none;
        border: 0;
        outline: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
        color: inherit;
        cursor: pointer;
    }

    img {
        max-width: 100%;
        width: 100%;
    }

    div.table-grid-wrap {
        border-bottom: 1px solid #EEE;
        display: flex;
        align-items: center;

        &:first-of-type {
            border-top: 1px solid #EEE;
        }

        div.row {
            flex: 1;
            display: flex;
            align-items: center;

            div.name {
                display: flex;
                align-items: center;
                gap: 4px;
                flex-basis: 120px;
                padding: 13px 20px;
                background-color: #FAFAFA;
                min-height: 48px;

                color: #555;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: 22px;
            }

            div.contents {
                padding: 8px 16px;
                flex: 1;
                background-color: #fff;
                height: 48px;
            }
        }
    }



    .Toastify__toast-container{
        z-index: 9999;
    }
    .Toastify__toast-container--top-center {
        top: 120px;
    }

    .Toastify__toast {
        border-radius: 4px !important;
        padding: 6px 16px !important;
        min-height: ${({theme}) => theme.SIZE.TOAST.height} !important;
        min-width: ${({theme}) => theme.SIZE.TOAST.width} !important;
        max-width: ${({theme}) => theme.SIZE.TOAST.maxWidth} !important;
        width: auto !important;
        max-height: 100% !important;
        margin: 0;
        line-height: ${({theme}) => theme.SIZE.TOAST.line_height};
        font-size: ${({theme}) => theme.SIZE.TOAST.font};
        font-weight: ${({theme}) => theme.SIZE.TOAST.weight};
        white-space: pre-line;
        justify-content: center;
    }

    .success-toast {
        background: ${({theme}) => theme.COLORS.TOAST.success.bg} !important;
        border: 1px solid ${({theme}) => theme.COLORS.TOAST.success.solid} !important;
        color: ${({theme}) => theme.COLORS.TOAST.success.font} !important;
    }

    .error-toast {
        background: ${({theme}) => theme.COLORS.TOAST.error.bg} !important;
        border: 1px solid ${({theme}) => theme.COLORS.TOAST.error.solid} !important;
        color: ${({theme}) => theme.COLORS.TOAST.error.font} !important;
    }

    .warning-toast {
        background: ${({theme}) => theme.COLORS.TOAST.warn.bg} !important;
        border: 1px solid ${({theme}) => theme.COLORS.TOAST.warn.solid} !important;
        color: ${({theme}) => theme.COLORS.TOAST.warn.font} !important;
    }

    .underline {
        text-decoration: underline;
        cursor: pointer;
        color: #007AFF;
    }

    .block {
        display: block;
    }

    .none {
        display: none;
    }

    .flex {
        display: flex;
    }
    
    .al-start{
        align-items: start !important;
    }
    
    .al-center {
        align-items: center;
    }
    
    .al-end {
        align-items: end;
    }

    .jc-center {
        justify-content: center;
    }

    .jc-between {
        justify-content: space-between;
    }

    .jc-start {
        justify-content: start;
    }

    .jc-end {
        justify-content: end;
    }

    .fd-column {
        flex-direction: column;
    }

    .shrink-0 {
        flex-shrink: 0;
    }

    .tx-al-right{
        text-align: right;
    }
    .tx-al-left{
        text-align: left;
    }
    .pointer {
        cursor: pointer;
    }

    .gap-0 {
        gap: 0 !important;
    }

    .gap-5 {
        gap: 5px;
    }
    
    .gap-8{
        gap: 8px;
    }
    
    .gap-10 {
        gap: 10px;
    }

    .gap-15 {
        gap: 15px;
    }

    .gap-20 {
        gap: 20px;
    }

    .gap-25 {
        gap: 25px;
    }

    .gap-30 {
        gap: 30px;
    }

    .w-full {
        width: 100%;
    }

    .w-half {
        width: 50%;
    }

    #root{
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .image-overlay{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgb(238, 238, 238);
        z-index: 1;
        transform: translate(0, 0);
        transition: all 1s ease-in-out;
    }
    .dragging {
        opacity: 0.5;
    }

    .required-mark{
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.02em;
        color: #246FF2;
        margin-left: 2px;
    }
    
    
    //.dropping {
    //    border: 2px dashed #3b82f6 !important;
    //    background-color: #eff6ff !important;
    //}
    .admin_wrapper{
        height: 100vh;
    }
    .admin-root{
        margin: 96px 0 0 280px;
        width: calc(100% - 280px);
        height: calc(100vh - 96px);
        background-color: #F2F2F2;
        padding: 40px;
        overflow: auto;
    }
    .view-img{
        cursor: pointer;
    }
    textarea{
        background-color: #fff;

    }
    .ck-powered-by{
        display: none;
    }
`;
export function setScreenHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
export default GlobalStyle;
